import { render } from "./TokenImage.vue?vue&type=template&id=dcb54a1c"
import script from "./TokenImage.vue?vue&type=script&lang=js"
export * from "./TokenImage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__